import { createAction } from '@ngrx/store';

export const ConfirmationPageLoad = createAction('[GA Confirmation] Page Load');

export type ConfirmationActions = typeof ConfirmationPageLoad;
